import axios from 'axios'
import { LOGOS_V2_URL } from '../constants/apiEndpoints'
import { GetLogoResponse } from '../types/GetLogoResponse'

export const getLogo = async (logoId: string, authorizationHeader: string): Promise<GetLogoResponse> => {
  return axios
    .get<GetLogoResponse>(`${LOGOS_V2_URL}/${logoId}`, {
      headers: {
        Authorization: `${authorizationHeader}`,
        'Content-Type': 'application/json',
      },
    })
    .then(response => response.data)
}
